import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from 'src/app/injection-constants';

@Injectable({
  providedIn: 'root'
})
export class ResyncService {

  constructor(private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string) { }

  resyncPim(): Observable<string>{
    return this.http.post<string>(`${this.apiBaseUrl}/management/backgroundTasks/pimResync`, null, {});
  }

  resyncIdentity(): Observable<string>{
    return this.http.post<string>(`${this.apiBaseUrl}/management/backgroundTasks/identityResync`, null, {});
  }

  catchUp(deleteAfterIngest = false): Observable<void> {
    const params = new HttpParams().set('deleteAfterIngest', String(deleteAfterIngest));
    return this.http.post<void>(`${this.apiBaseUrl}/management/backgroundTasks/deadlettercatchup`, null, { params });
  }
}
